<template>
    <v-container>
        <v-form ref="form" @submit.prevent="saveQuestion" class="custom_form">
            <v-card>
             
               
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5"> Statement </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="questionStatement"
                                outlined
                                dense
                                clearable
                                @click="editTextStatement($event)"
                            
                            ></v-text-field>
                        </v-col>
                    </v-row>

                   

                    

                  

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5">
                                Question Status
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="questionStatus"
                                inset
                                dense
                                class="mt-2"
                                color="blue"
                                :label="
                                    questionStatus
                                        ? 'Active'
                                        : 'Inactive'
                                "
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <!-- <v-row v-if="errorMessage || successMessage">
                        <v-col cols="6" offset-md="2">
                            <v-alert v-if="errorMessage" type="error">
                                {{ errorMessage }}
                            </v-alert>
                            <v-alert v-if="successMessage" type="success">
                                {{ successMessage }}
                            </v-alert>
                        </v-col>
                    </v-row> -->
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)"
                                    >cancel</v-btn
                                >
                                <v-btn
                                    class="mx-5"
                                   
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="saveQuestion"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>

import axios from "axios";
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/");
                }
            }, 0);
        });
    },
    name: "AddTypeThreeQuestion",
    components: {
      
    },
    data() {
        return {
           questionStatement:'',
           questionStatus:false,
            

         }
            
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods: {
       
        

        saveQuestion() {
            axios
                    .put(
                        "http://15.206.163.193/api/question/Adminquestiontypethree",
                        {
                            "Statement":this.questionStatement,
                             "status":this.questionStatus,
                        },
                        {
                            headers: { "x-auth-token": this.auth.token }
                        }
                    )
                    .then(res => {
                        console.log("text", res);
                    })
                    .catch(err => console.error(err.response.data));
    

           
           
}



       
        

       
    },
    watch: {
      
    },
    mounted() {
        // this.getThaats();
    }
   
};
</script>

<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
.custom_form >>> .v-card__text {
    padding: 10px 16px;
}
.custom_form >>> .v-badge__badge.blue {
    height: 30px;
    min-width: 30px;
    border-radius: 50px;
}
.custom_form >>> .mdi-pencil-outline::before {
    font-size: 18px;
}
.custom_form >>> .v-input__append-outer,
.custom_form >>> .v-input__prepend-outer {
    margin-top: 9px;
}
</style>
